import { render, staticRenderFns } from "./approval_template.vue?vue&type=template&id=4cf514d8&scoped=true&"
import script from "./approval_template.vue?vue&type=script&lang=js&"
export * from "./approval_template.vue?vue&type=script&lang=js&"
import style0 from "./approval_template.vue?vue&type=style&index=0&id=4cf514d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf514d8",
  null
  
)

export default component.exports